package org.gymly.api.dto

import kotlinx.serialization.Serializable

/** Términos y compromisos del socio: texto vigente, aceptación y estado de suspensión. */
@Serializable
data class PortalTermsDto(
    val version: String,
    val title: String,
    val body: String,
    val accepted: Boolean,
    val marketingWhatsApp: Boolean,
    val suspended: Boolean = false,
    /** TERMS_DECLINED (rechazó los términos) o ADMIN (suspensión administrativa). */
    val suspensionReason: String? = null,
    val suspensionNote: String? = null,
    /** false = el gimnasio no exige aceptar términos (monitoreo apagado). */
    val required: Boolean = true,
)

@Serializable
data class PortalAcceptTermsRequestDto(val version: String, val marketingWhatsApp: Boolean)

/** "No acepto": solo lleva la versión que se leyó. */
@Serializable
data class PortalDeclineTermsRequestDto(val version: String)

/** Membresía con tarjeta o PayPal: el servidor arma el monto con el plan; el móvil solo elige plan y entrenador. */
@Serializable
data class PortalMembershipCheckoutRequestDto(
    val planId: String,
    val trainerId: String,
    val method: String,
    val notes: String? = null,
    val returnUrl: String,
)

@Serializable
data class PortalMembershipCheckoutDto(val paymentId: String, val url: String)

@Serializable
data class PortalMembershipCheckoutStatusDto(val paymentId: String, val paid: Boolean)
